@if (householdStudent?.id) {
  <cfi-record-view
    [title]="getHeaderTitle()"
    [headerMetaLabel]="'PID :'"
    [headerMetaValue]="getHeaderPid()"
    [sections]="sections"
    [form]="form"
    [options]="options"
    [columns]="4"
    [prefix]="'student_information'"
    [canEdit]="showEditButton()"
    [useGrayTheme]="true"
    (edit)="onEditClick()">
    @if (showInitiateSchoolTransferButton()) {
      <button
        class="primary_materials_button record-view-initiate-transfer-button"
        type="button"
        [disabled]="isInitiateSchoolTransferDisabled()"
        (click)="onInitiateSchoolTransferClick()"
        id="student_information_initiate_transfer_button"
        data-pw="student_information_initiate_transfer_button"
        data-qa="student_information_initiate_transfer_button">
        {{ getInitiateSchoolTransferButtonLabel() }}
      </button>
    }

    @if (showChangeGuardianButton()) {
      <button
        class="primary_materials_button record-view-change-guardian-button"
        type="button"
        (click)="onChangeGuardianClick()"
        id="student_information_change_guardian_button"
        data-pw="student_information_change_guardian_button"
        data-qa="student_information_change_guardian_button">
        Change Guardian
      </button>
    }
  </cfi-record-view>
} @else {
  <div class="details-card">
    <h5 aria-level="3" id="schoolDetailsHeading">No Students found</h5>
  </div>
}
